import {observer} from "mobx-react";
import {authStore, DialogStore, fmsPackageDetailStore} from "../../../store";
import {displayShipmentProcessType, displayShipmentType} from "../../../api";
import {ShipmentTypeDto} from "../../../api/fms";
import {fmsReceiverStore} from "../../../store/fms/FmsReceiverStore";
import {Linq} from "../../ui";

interface FmsDetailIntroProps {
    shipmentTypeDialogStore: DialogStore
    receiverDialogStore: DialogStore
}

const FmsDetailIntro = observer(function FmsDetailIntro({
                                                            shipmentTypeDialogStore,
                                                            receiverDialogStore
                                                        }: FmsDetailIntroProps) {
    return <div
        style={{
            padding: '1em',
            display: 'flex'
        }}
    >
        <div
            style={{
                flex: '1'
            }}
        >
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Kunde</label>
                <Linq to={`/cms/${fmsPackageDetailStore.data?.customerId}`}>
                    <h4 className={"title is-4 has-text-primary"}>
                        {`${fmsPackageDetailStore.data?.customerDisplay}`}
                    </h4>
                </Linq>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Prozess</label>
                <h4 className={"title is-4 has-text-primary"}>
                    {displayShipmentProcessType(fmsPackageDetailStore.data?.processType)}
                </h4>
            </div>
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Versandart</label>
                <h4 className={"title is-4 has-text-primary"}>
                    {displayShipmentType(fmsPackageDetailStore.data?.shipmentType)}
                    {
                        authStore.hasRole('FULFILMENT_WRITE')
                        && fmsPackageDetailStore.active
                        && fmsPackageDetailStore.data?.shipmentType !== ShipmentTypeDto.POST
                        && <span
                            onClick={() => {
                                shipmentTypeDialogStore.dialogOpen = true
                            }}
                            className="material-symbols-outlined has-text-warning"
                            style={{marginLeft: '0.5em', cursor: 'pointer'}}>edit</span>
                    }
                </h4>
            </div>
            {fmsPackageDetailStore.data?.shipmentLabel?.trackingNumber && <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Tracking</label>
                <span className={"label has-text-primary"}>{fmsPackageDetailStore.data?.shipmentLabel?.trackingNumber}</span>
            </div>}
        </div>
        <div
            style={{
                flex: '1'
            }}
        >
            {Boolean(fmsPackageDetailStore.data?.compartment) &&
                <div style={{marginBottom: '1em'}}>
                    <label className={"label has-text-info"} style={{marginBottom: '0'}}>Regalfach</label>
                    <h4 className={"title is-4 has-text-primary"}>{fmsPackageDetailStore.data?.compartment}</h4>
                </div>}
            <div style={{marginBottom: '1em'}} className={"has-text-primary label"}>
                <div className={"is-flex"}>
                    <label className={"label has-text-info"} style={{marginBottom: '0'}}>Empfänger</label>
                    {
                        authStore.hasRole('FULFILMENT_UPDATE_RECEIVER')
                        && fmsPackageDetailStore.active
                        && fmsPackageDetailStore.data?.shipmentType !== ShipmentTypeDto.POST
                        && <span
                            onClick={() => {
                                fmsReceiverStore.reset(false)
                                if (fmsPackageDetailStore.data) {
                                    fmsReceiverStore.formData = {
                                        packageId: fmsPackageDetailStore.id,
                                        version : fmsPackageDetailStore.data?.audit.version,
                                        line1: fmsPackageDetailStore.data?.receiver.line1,
                                        line2: fmsPackageDetailStore.data?.receiver.line2 || '',
                                        street: fmsPackageDetailStore.data?.receiver.address.street,
                                        city: fmsPackageDetailStore.data?.receiver.address.city,
                                        country: fmsPackageDetailStore.data?.receiver.address.country,
                                        addition: fmsPackageDetailStore.data?.receiver.address.addition || '',
                                        houseNumber: fmsPackageDetailStore.data?.receiver.address.houseNumber || '',
                                        postCode: fmsPackageDetailStore.data?.receiver.address.postCode,
                                        mail: fmsPackageDetailStore.data?.receiver.mail || '',
                                        phone: fmsPackageDetailStore.data?.receiver.phone || '',
                                    }
                                }
                                fmsReceiverStore.validate().then(() => receiverDialogStore.dialogOpen = true)
                            }}
                            className="material-symbols-outlined has-text-warning"
                            style={{marginLeft: '0.5em', cursor: 'pointer'}}>edit</span>
                    }
                </div>
                <div>{fmsPackageDetailStore.data?.receiver.line1}</div>
                <div>{fmsPackageDetailStore.data?.receiver.line2}</div>
                <div>
                    {fmsPackageDetailStore.data?.receiver.address.street
                    } {fmsPackageDetailStore.data?.receiver.address.houseNumber
                } {fmsPackageDetailStore.data?.receiver.address.addition}
                </div>
                <div>
                    {fmsPackageDetailStore.data?.receiver.address.postCode
                    } {fmsPackageDetailStore.data?.receiver.address.city}
                </div>
                {fmsPackageDetailStore.data?.receiver.phone &&
                    <div>Telefon: {fmsPackageDetailStore.data?.receiver.phone}</div>}
                {fmsPackageDetailStore.data?.receiver.mail &&
                    <div>Email: {fmsPackageDetailStore.data?.receiver.mail}</div>}
            </div>
        </div>
    </div>
})

export {
    FmsDetailIntro
}
